import React, { useState, useRef, useEffect } from "react";
import { Row, Col } from "reactstrap";
import { useLocation } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import { TextField, Button, Box, Typography } from "@mui/material";
//components
import Loader from "./Loader/Loader";
import SortAssendingicon from "./Icons/SortAssendingicon";
import SortDescendingIcon from "./Icons/SortDescendingIcon";
let dataSet: any = [];
let processedData: any = [];
const Index = (props: any) => {
  const location: any = useLocation();
  const [selectSortFields, setSelectSortFields]: any = React.useState({
    sort: "",
    fieldName: "",
  });
  let headerData = props.headerData;

  const binder = (dataItem: any, index: any) => {
    const headers = headerData?.columns || [];
    // One cell per header, in header order. Missing fields stay empty so
    // later values cannot slide into the wrong column.
    const dataSetItem = headers.map((headItem: any) =>
      dataItem != null &&
      Object.prototype.hasOwnProperty.call(dataItem, headItem.field)
        ? dataItem[headItem.field]
        : null
    );
    dataSet[index] = dataSetItem;
    processedData = dataSet;
  };
  var formatter = (data: any) => {
    dataSet = [];
    data.map((dataItem: any, index: any) => {
      binder(dataItem, index);
      return true;
    });
  };
  let columnWidthArray: any = [];
  headerData?.columns?.forEach((item: any) => {
    columnWidthArray.push(item.width);
  });
  if (props.data?.length > 0) {
    formatter(props.data);
  }
  const totalPages = Number(props.totPages) > 0 ? Number(props.totPages) : 0;
  const shownTotal = Number(props.totCnt);
  const safeTotal = Number.isFinite(shownTotal) ? shownTotal : 0;
  const safeFrom = Number.isFinite(Number(props.fromVal)) ? Number(props.fromVal) : 0;
  const safeTo = Number.isFinite(Number(props.toVal)) ? Number(props.toVal) : 0;
  const rawPage = parseInt(String(props.offset ?? 0), 10) + 1;
  const currentPage =
    totalPages > 0 ? Math.min(Math.max(Number.isFinite(rawPage) ? rawPage : 1, 1), totalPages) : 1;
  const columnCount = headerData?.columns?.length || 0;
  const usePin = props.pin !== false && columnCount > 0;
  const tableClass =
    (columnCount >= 11 ? "tableParent1" : "tableParent") +
    (usePin ? " hkp-table-scroll" : "");
  // First load (nothing to show yet) gets a loader inside the table; a refresh of an
  // existing list just dims the rows. The toolbar always stays mounted so a search
  // box being typed in never loses focus, and nothing is inserted above the table.
  const firstLoad = Boolean(props?.loading) && !(props.data?.length > 0);
  const listBody = (
        <>
          {props.toolbar ? (
            <div className="hkp-list-pin__toolbar">{props.toolbar}</div>
          ) : null}
          <div
            className={tableClass + (props?.loading && !firstLoad ? " is-refreshing" : "")}
            aria-busy={props?.loading ? true : undefined}
          >
            <div className={usePin ? "hkp-table-scroll__inner" : undefined}>
              <Row className={"tableHeaderRow"}>
                {headerData?.columns?.map((headItem: any, index: any) => {
                  return (
                    <React.Fragment key={index}>
                      <Col
                        className="product-list-th"
                        key={index}
                        data-field={headItem.field}
                        style={{
                          flex: columnWidthArray[index],
                          minWidth: 0,
                          textAlign:
                            location?.pathname.split(":")[0] === "/products"
                              ? headItem.label === "Actions"
                                ? "center"
                                : "left"
                              : "left",
                        }}
                      >
                        {headItem.label}{" "}
                        {headItem?.sort === true ? (
                          <>
                            {selectSortFields?.sort == "asc" &&
                              selectSortFields.fieldName == headItem.field ? (
                              <SortDescendingIcon
                                handleSort={() => {
                                  props.handleSort({
                                    name: headItem.field,
                                    sort: "desc",
                                  });
                                  setSelectSortFields({
                                    sort: "desc",
                                    fieldName: headItem.field,
                                  });
                                }}
                              />
                            ) : (
                              <>
                                {selectSortFields?.sort == "desc" &&
                                  selectSortFields.fieldName == headItem.field ? (
                                  <SortAssendingicon
                                    handleSort={() => {
                                      props.handleSort({
                                        name: headItem.field,
                                        sort: "asc",
                                      });
                                      setSelectSortFields({
                                        sort: "asc",
                                        fieldName: headItem.field,
                                      });
                                    }}
                                  />
                                ) : (
                                  <SortAssendingicon
                                    handleSort={() => {
                                      props.handleSort({
                                        name: headItem.field,
                                        sort: "asc",
                                      });
                                      setSelectSortFields({
                                        sort: "asc",
                                        fieldName: headItem.field,
                                      });
                                    }}
                                  />
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </React.Fragment>
                  );
                })}
              </Row>
              {props.data?.length > 0 && processedData?.length > 0 ? (
                processedData.map((Item: any, index: any) => {
                  return (
                    <div className="tableBodyDeatils" key={index}>
                      <Row
                        className={index % 2 === 0 ? "EvenRow" : "OddRow"}
                        style={{
                          alignItems: "start",
                          textAlign: "left",
                        }}
                      >
                        {headerData?.columns?.map((headItem: any, colIndex: any) => {
                          const dataItem = Item?.[colIndex];
                          return (
                            <Col
                              className="IndexDatatableNeoCol"
                              key={headItem.field || colIndex}
                              data-field={headItem.field}
                              style={{
                                flex: columnWidthArray[colIndex],
                                minWidth: 0,
                              }}
                            >
                              {dataItem}
                            </Col>
                          );
                        })}
                      </Row>
                    </div>
                  );
                })
              ) : firstLoad ? (
                <div className="hkp-list-loading">
                  <Loader />
                </div>
              ) : (
                <div className="noListingPage">
                      <div>{ props?. message ? props?. message :"No Records Found"}
                        </div>
                </div>
              )}
            </div>
            {props.afterRows}
          </div>
          {props.hidePagination || safeTotal <= 0 ? null : (
          <div className="paginationDiv">
            <span>
              Showing {safeFrom} to {safeTo} of {safeTotal} entries
            </span>
            {totalPages > 0 && (
                <div className="pagination-controls">
                  <Pagination
                    size="small"
                    shape="rounded"
                    count={totalPages}
                    color="primary"
                    page={currentPage}
                    onChange={props.handleChange}
                    defaultPage={1}
                    siblingCount={1}
                  />
                  <PageJumpControl
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageJump={props.handleChange}
                  />
                </div>
            )}
          </div>
          )}
        </>
  );

  return (
    <>
      {usePin ? (
        <div className="hkp-list-pin">{listBody}</div>
      ) : (
        listBody
      )}
    </>
  );
};

// Page Jump Control Component
const PageJumpControl = ({ currentPage, totalPages, onPageJump }: any) => {
  const [pageInput, setPageInput] = useState("");
  const [error, setError] = useState("");
  const [errorPosition, setErrorPosition] = useState("below");
  const containerRef = useRef<HTMLDivElement>(null);

  // Update error position on window resize and orientation change
  useEffect(() => {
    const updateErrorPosition = () => {
      if (error) {
        checkErrorPosition();
      }
    };

    const debouncedUpdate = debounce(updateErrorPosition, 100);

    window.addEventListener('resize', debouncedUpdate);
    window.addEventListener('orientationchange', debouncedUpdate);

    return () => {
      window.removeEventListener('resize', debouncedUpdate);
      window.removeEventListener('orientationchange', debouncedUpdate);
    };
  }, [error]);

  // Simple debounce function to prevent excessive calls
  const debounce = (func: Function, wait: number) => {
    let timeout: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(null, args), wait);
    };
  };

  const handlePageJump = () => {
    const targetPage = parseInt(pageInput, 10);
    
    if (!pageInput || isNaN(targetPage)) {
      setError("Please enter a valid page number");
      checkErrorPosition();
      return;
    }
    
    // Handle very large numbers that could cause issues
    if (targetPage > 999999) {
      setError("Page number too large. Please enter a reasonable page number");
      checkErrorPosition();
      return;
    }
    
    if (targetPage < 1) {
      setError("Page number cannot be less than 1");
      checkErrorPosition();
      return;
    }
    
    // Ensure totalPages is valid
    if (!totalPages || totalPages < 1) {
      setError("Unable to navigate. No pages available");
      checkErrorPosition();
      return;
    }
    
    if (targetPage > totalPages) {
      setError(`Exceeding max number of pages. Maximum pages available: ${totalPages}`);
      checkErrorPosition();
      return;
    }
    
    setError("");
    setPageInput("");
    onPageJump(null, targetPage);
  };

  const checkErrorPosition = () => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;
      const spaceBelow = viewportHeight - rect.bottom;
      const spaceAbove = rect.top;
      
      // Consider both vertical space and ensure error fits horizontally
      const errorHeight = 50; // Approximate error message height
      const errorWidth = 240; // Max error width from CSS
      
      // Check if error would fit below
      const fitsBelow = spaceBelow >= errorHeight;
      // Check if error would fit above
      const fitsAbove = spaceAbove >= errorHeight;
      // Check if error fits horizontally (considering right alignment)
      const fitsHorizontally = rect.right >= errorWidth || viewportWidth >= errorWidth;
      
      if (fitsBelow && fitsHorizontally) {
        setErrorPosition("below");
      } else if (fitsAbove && fitsHorizontally) {
        setErrorPosition("above");
      } else {
        // Default to below if neither fits perfectly
        setErrorPosition("below");
      }
    }
  };

  const handleKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      handlePageJump();
    }
  };

  const handleInputChange = (e: any) => {
    const value = e.target.value;
    
    // Limit input length to prevent extremely long numbers
    if (value.length > 6) {
      setError("Page number too long. Please enter a reasonable page number");
      checkErrorPosition();
      return;
    }
    
    // Only allow positive integers (no decimals, no negative numbers)
    if (value === "" || /^[1-9]\d*$|^0$/.test(value)) {
      setPageInput(value);
      setError("");
    }
    // If user tries to enter decimal point, show immediate feedback
    else if (value.includes('.')) {
      setError("Please enter a whole number only");
      checkErrorPosition();
    }
    // If user tries to enter negative numbers or other invalid characters
    else if (value.includes('-') || /[^\d.]/.test(value)) {
      setError("Please enter positive numbers only");
      checkErrorPosition();
    }
  };

  if (totalPages <= 1) return null;

  return (
    <Box className="page-jump-container">
      <Typography variant="body2" className="page-jump-label">
        Go to page:
      </Typography>
      <Box className="page-jump-input-container" ref={containerRef}>
        <TextField
          size="small"
          value={pageInput}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          placeholder="Page"
          className="page-jump-input"
          inputProps={{
            style: {
              textAlign: 'center',
              minWidth: '60px',
              maxWidth: '80px'
            }
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              height: '32px',
              minWidth: '60px',
              maxWidth: '80px',
              '& input': {
                padding: '6px 8px',
                fontSize: '14px'
              }
            }
          }}
        />
        {error && (
          <Typography 
            variant="caption" 
            color="error" 
            className={`page-jump-error ${errorPosition === "above" ? "error-above" : ""}`}
          >
            {error}
          </Typography>
        )}
      </Box>
      <Button
        size="small"
        variant="outlined"
        onClick={handlePageJump}
        className="page-jump-button"
        sx={{
          height: '32px',
          minWidth: '50px',
          fontSize: '12px',
          padding: '4px 8px'
        }}
      >
        Go
      </Button>
    </Box>
  );
};

export { PageJumpControl };
export default Index;
